import { useQuery } from '@tanstack/react-query';
import { fetchCertification } from '../api/certifications';
import { useCertStore } from '../stores/certStore';

/**
 * Fetch certification detail for the given code, or the active certification
 * from certStore if no code is provided.
 * Caches for 10 minutes since exam parameters change infrequently.
 */
export function useCertification(code?: string) {
  const storeCode = useCertStore((s) => s.certCode);
  const certCode = code ?? storeCode;

  return useQuery({
    queryKey: ['certification', certCode],
    queryFn: () => fetchCertification(certCode),
    staleTime: 10 * 60 * 1000,
    enabled: !!certCode,
  });
}
